import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ToggleService {

    private isSidebarToggled = new BehaviorSubject<boolean>(false);

    get isSidebarToggled$() {
        return this.isSidebarToggled.asObservable();
    }

    /** Flips the sidebar open/closed. */
    toggle() {
        this.isSidebarToggled.next(!this.isSidebarToggled.value);
    }

    /**
     * Forces the sidebar closed without toggling.
     * Called when the viewport resizes above the mobile breakpoint
     * so the desktop layout is never left in an open-mobile state.
     */
    reset() {
        this.isSidebarToggled.next(false);
    }
}